import React from "react";
import { compose, withAppContext, withActions, withState } from "containers/HOC";
import { withRouter, matchPath } from "react-router-dom";
import { Form, Field } from "react-final-form";
import * as FormUtils from "common/FormUtils";
import Modal from "components/new/Modal";
import ModalBody from "components/new/ModalBody";
import ModalFooter from "components/new/ModalFooter";
import Alert from "components/Alert";
import Panel from "components/Panel/Panel";
import PanelBody from "components/Panel/PanelBody";
import Grid from "components/Grid";
import GridCell from "components/GridCell";
import TextareaPack from "components/TextareaPack";
import InputPack from "components/InputPack";
import { getTickets, submitRequest } from "./_actions";

class SupportModal extends React.Component {
    state = {};

    componentDidMount() {
        this.props.getTickets();
    }

    _validate = (values) => {
        const errors = {};

        errors.farmName = FormUtils.validators.maxLength(300)(values.farmName);

        errors.budgetName = FormUtils.validators.maxLength(300)(values.budgetName);

        errors.subject = FormUtils.validators.required(values.subject);
        errors.subject = errors.subject || FormUtils.validators.maxLength(100)(values.subject);

        errors.request = FormUtils.validators.required(values.request);
        errors.request = errors.request || FormUtils.validators.maxLength(1000)(values.request);

        return errors;
    };

    _save = (values) => {
        this.props.submitRequest(values);
    };

    selectTicket = (ticket) => (e) => {
        this.setState({ selectedTicket: ticket });
    };

    render() {
        const { supportRequest, tickets } = this.props;

        let body = supportRequest.farmName ? `Farm: ${supportRequest.farmName} ` : "";
        body += supportRequest.budgetName ? ` | Analyses: ${supportRequest.budgetName}` : "";

        return (
            <Form initialValues={supportRequest} validate={this._validate} onSubmit={this._save}>
                {({ values, handleSubmit, submitSucceeded }) => {
                    return (
                        <Modal title="Support" allowOffline={false}>
                            {({ closeModal }) => (
                                <form onSubmit={handleSubmit}>
                                    <ModalBody>
                                        <Panel title="User guides" className="u-mt-md" skyBlue open={false}>
                                            <PanelBody>
                                                <div className="u-mt-md">
                                                    <a href={`https://docs.overseer.org.nz/${process.env.REACT_APP_PRODUCT}/OverseerUserGuide.pdf`} target="_blank" rel="noopener noreferrer" id="lnk-open-guide">
                                                        Full user guide
                                                    </a>
                                                </div>
                                                <div className="u-mt-md">
                                                    <a href={`https://docs.overseer.org.nz/${process.env.REACT_APP_PRODUCT}/OverseerBlocks.pdf`} target="_blank" rel="noopener noreferrer" id="lnk-open-guide">
                                                        How to set up blocks in Overseer
                                                    </a>
                                                </div>
                                                <div className="u-mt-md">
                                                    <a href={`https://docs.overseer.org.nz/${process.env.REACT_APP_PRODUCT}/OverseerWetlandGuide.pdf`} target="_blank" rel="noopener noreferrer" id="lnk-open-guide">
                                                        Wetland photos and definitions
                                                    </a>
                                                </div>
                                            </PanelBody>
                                        </Panel>

                                        {tickets && tickets.length > 0 && (
                                            <Panel title={"Existing tickets - Maximum of 5 tickets shown"} skyBlue open={false}>
                                                <PanelBody>
                                                    <div className="Table u-mt-md">
                                                        <table>
                                                            <tbody>
                                                                <tr key="">
                                                                    <th>ID</th>
                                                                    <th>Subject</th>
                                                                    <th>Status</th>
                                                                    <th>Description</th>
                                                                </tr>
                                                                {tickets.map((ticket, i) => {
                                                                    const selected = this.state.selectedTicket && ((this.state.selectedTicket.id && this.state.selectedTicket.id === ticket.id) || (this.state.selectedTicket.tempId && this.state.selectedTicket.tempId === ticket.tempId));
                                                                    return (
                                                                        <tr key={"ticket-" + i} className={selected ? "Table-tr--blue is-selected" : ""} onClick={this.selectTicket(ticket)}>
                                                                            <td>{ticket.id ? ticket.id : "-"}</td>
                                                                            <td>{ticket.subject}</td>
                                                                            <td>{ticket.status}</td>
                                                                            <td>{ticket.description.split("\n")[0]}</td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    {this.state.selectedTicket && (
                                                        <div className="Grid-cell Support-area">
                                                            <TextareaPack meta={{ nrf: true }} style={{ height: "300px" }} label="Request" value={this.state.selectedTicket.description} />
                                                        </div>
                                                    )}
                                                </PanelBody>
                                            </Panel>
                                        )}

                                        <Panel title="Create new support request" notCollapsible={true} skyBlue>
                                            <Alert type="info" text="If you are currently in an analysis, the farm and analysis have been populated for you. Please change these values if they are not relevant to the request." />
                                            <PanelBody>
                                                <Grid>
                                                    <GridCell className="u-width1of2">
                                                        <Field name="farmName" label="Farm" placeholder="Farm name if applicable" type="text" component={InputPack} />
                                                    </GridCell>
                                                    <GridCell className="u-width1of2">
                                                        <Field name="budgetName" label="Analysis" placeholder="Analysis name if applicable" type="text" component={InputPack} />
                                                    </GridCell>
                                                    <GridCell>
                                                        <Field name="subject" label="Subject" placeholder="Enter the subject of the request" required type="text" component={InputPack} />
                                                    </GridCell>
                                                    <GridCell className="Support-area">
                                                        <Field name="url" type="hidden" component="input" />
                                                        <Field name="request" style={{ height: "300px" }} label="Request" placeholder="Enter the details for your request." requiredLabel={true} component={TextareaPack} />
                                                        <div>
                                                            Alternatively you can email support at <a href={`mailto:support@overseer-helpdesk.zendesk.com?body=${body}`}>support@overseer-helpdesk.zendesk.com</a>
                                                        </div>
                                                    </GridCell>
                                                </Grid>
                                            </PanelBody>
                                        </Panel>
                                    </ModalBody>
                                    <ModalFooter>
                                        <div className="ButtonBar">
                                            <div className="ButtonBar-left">
                                                <button id="cancel-button" type="button" className="Button Button--secondary" onClick={closeModal}>
                                                    Cancel
                                                </button>
                                            </div>
                                            <div className="ButtonBar-right">
                                                <button id="save-button" type="submit" className="Button" disabled={submitSucceeded}>
                                                    Send
                                                </button>
                                            </div>
                                        </div>
                                    </ModalFooter>
                                </form>
                            )}
                        </Modal>
                    );
                }}
            </Form>
        );
    }
}
export default compose(
    withRouter,
    withAppContext,
    withActions({ getTickets, submitRequest }),
    withState((state, ownProps) => {
        const budgetLocation = matchPath(ownProps.location.pathname, {
            path: "/app/farm/:farmId/analysis/:budgetId",
        });
        const farmLocation = budgetLocation
            ? undefined
            : matchPath(ownProps.location.pathname, {
                  path: "/app/farm/:farmId",
              });
        const farmId = budgetLocation ? budgetLocation.params.farmId : farmLocation ? farmLocation.params.farmId : undefined;
        const budgetId = budgetLocation ? budgetLocation.params.budgetId : undefined;
        const offlineFarm = state.offlineFarms.find((f) => f.id === farmId);
        const offlineBudget = offlineFarm && offlineFarm.farm ? (offlineFarm.farm.offlineBudgets || []).find((b) => b.id === budgetId) : null;

        return {
            tickets: state.support.tickets,
            supportRequest: {
                farmName: offlineFarm ? offlineFarm.farm.name : undefined,
                budgetName: offlineBudget ? offlineBudget.budget.name : undefined,
                url: (ownProps.location || {}).pathname,
            },
        };
    })
)(SupportModal);
